import React from 'react';
import { Card, Input, Space, Button, message } from 'antd';

const { TextArea } = Input;

const Base64Tool: React.FC = () => {
  const [originalText, setOriginalText] = React.useState('');
  const [encodedText, setEncodedText] = React.useState('');

  // Base64编码
  const encode = () => {
    if (!originalText.trim()) {
      message.error('请输入要编码的文本');
      return;
    }

    try {
      const encoded = btoa(unescape(encodeURIComponent(originalText)));
      setEncodedText(encoded);
      message.success('编码成功');
    } catch (error) {
      message.error('编码失败');
    }
  };

  // Base64解码
  const decode = () => {
    if (!encodedText.trim()) {
      message.error('请输入要解码的Base64文本');
      return;
    }

    try {
      const decoded = decodeURIComponent(escape(atob(encodedText.trim())));
      setOriginalText(decoded);
      message.success('解码成功');
    } catch (error) {
      message.error('解码失败，请检查Base64格式是否正确');
    }
  };

  const copyOriginal = () => {
    if (originalText) {
      navigator.clipboard.writeText(originalText);
      message.success('已复制原文到剪贴板');
    }
  };

  const copyEncoded = () => {
    if (encodedText) {
      navigator.clipboard.writeText(encodedText);
      message.success('已复制编码结果到剪贴板');
    }
  };

  const clearAll = () => {
    setOriginalText('');
    setEncodedText('');
    message.info('已清空所有内容');
  };

  return (
    <Card title="Base64 编码/解码" className="tool-container-responsive">
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>原文</div>
          <TextArea
            placeholder="输入要编码的文本"
            value={originalText}
            onChange={e => setOriginalText(e.target.value)}
            rows={6}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyOriginal} disabled={!originalText}>
                复制原文
              </Button>
              <Button type="primary" onClick={encode}>
                Base64编码
              </Button>
            </Space>
          </div>
        </div>

        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>Base64编码结果</div>
          <TextArea
            placeholder="输入要解码的Base64文本"
            value={encodedText}
            onChange={e => setEncodedText(e.target.value)}
            rows={6}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyEncoded} disabled={!encodedText}>
                复制编码
              </Button>
              <Button type="primary" onClick={decode}>
                Base64解码
              </Button>
              <Button onClick={clearAll}>
                清空
              </Button>
            </Space>
          </div>
        </div>
      </Space>
    </Card>
  );
};

export default Base64Tool; 